"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedRatingsFormPayloadSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = require("zod");
const parent_rating_row_1 = require("../../../../../PackageStore/parent-rating-row");
const stored_ratings_table_1 = require("../../../../../RatingsTable/stored-ratings-table");
exports.NormalizedRatingsFormPayloadSchema = z.object({
    boundaries: sigma_engine_shared_1.ComponentBoundarySchema.array(),
    modes: sigma_engine_shared_1.ModeBaseSchema.array(),
    differentialPairs: sigma_engine_shared_1.DifferentialPairSchema.array(),
    table: stored_ratings_table_1.StoredRatingsTableSchema.nullable(),
    parentRows: parent_rating_row_1.ParentRatingRowSchema.array(),
});
//# sourceMappingURL=payload.js.map